import { render } from "./PhotoViewer.vue?vue&type=template&id=59738792&ts=true"
import script from "./PhotoViewer.vue?vue&type=script&lang=ts"
export * from "./PhotoViewer.vue?vue&type=script&lang=ts"

import "./PhotoViewer.vue?vue&type=style&index=0&id=59738792&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__